import { useNavigate } from 'react-router-dom';

interface Props {
  nome: string;
  /** Faixa da arte do evento (120 px, cantos arredondados). */
  imagem: string | null;
  /** "21/11 · 19:30" (ou null quando o evento não tem data). */
  dataHora: string | null;
  /** Local curto do evento. */
  local: string | null;
  /** Tipo/opção do ingresso (ex.: "Inteiro · Masculino"). */
  tipo?: string | null;
}

// Topo da compra do ingresso: fundo claro, faixa da arte (mesma das fichas),
// nome do evento e data/local em no máximo duas linhas.
export default function TopoIngresso({ nome, imagem, dataHora, local, tipo }: Props) {
  const navigate = useNavigate();
  const onde = [dataHora, local].filter(Boolean).join(' · ');

  return (
    <header className="mx-auto w-full max-w-[560px] px-4 pt-3">
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => navigate(-1)}
          aria-label="Voltar"
          className="aperta flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full bg-background-50 text-foreground-800 shadow-pcard transition-colors hover:bg-background-100"
        >
          <i className="ri-arrow-left-line text-[20px]" aria-hidden />
        </button>
        <p className="truncate text-[12.5px] font-semibold uppercase tracking-[0.12em] text-foreground-500">
          Comprar ingresso
        </p>
      </div>

      {imagem && (
        <div className="mt-3 h-[120px] w-full overflow-hidden rounded-[16px] bg-background-200">
          <img
            src={imagem}
            alt={nome}
            title={nome}
            className="h-full w-full object-cover object-top"
            decoding="async"
          />
        </div>
      )}

      <h1 className="mt-3 text-[20px] font-extrabold leading-tight text-foreground-950">{nome}</h1>
      {onde && (
        <p className="mt-0.5 line-clamp-2 text-[13px] leading-snug text-foreground-600">{onde}</p>
      )}
      {tipo && (
        <span className="mt-2 inline-flex max-w-full items-center gap-1 rounded-full bg-background-100 px-2.5 py-1 text-[11.5px] font-bold text-foreground-700">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-ticket-2-line text-[13px]" aria-hidden />
          </span>
          <span className="truncate">{tipo}</span>
        </span>
      )}
    </header>
  );
}